/**
 * @format
 */

var AbstractViewModel = require("./AbstractViewModel");

/**
 * Notification Settings
 *
 * @param {UserPreferences} userPreferences
 */
function NotificationSettingsViewModel(
  userPreferences,
  queues,
  selectedLocations,
  selectedQueues
) {
  var self = this;

  this.userPreferences = userPreferences;
  this.selectedQueues = selectedQueues;
  this.queues = queues;
  this.selectedLocations = selectedLocations;
  this.showDesktopNotifications = ko.observable(false);

  this.enabledQueues = ko.observableArray();
  this.enabledQueues.subscribe(function (value) {
    this.showDesktopNotifications((value.length > 0))  
    this.requestPermissionOrDisable(value)
  }, this);

  this.enabledAllQueues = ko.pureComputed(
    {
      read: function () {
        var allQueuesSelected = this.queues().every(
          function (queue) {
            return this.enabledQueues().indexOf(queue.id) !== -1;
          }.bind(this)
        );

        return allQueuesSelected;
      },
      write: function (enableAll) {
        if (enableAll) {
          this.enabledQueues(
            this.queues().map(function (q) {
              return q.id;
            })
          );
        } else {
          this.enabledQueues([]);
        }
      },
      deferEvaluation: true,
      owner: this,
    },
    this
  );

  this.locationQueues = ko.deferredComputed(function () {
    var locations = this.selectedLocations();
    var selectedQueueIds = this.selectedQueues().map(function (q) {
      return q.id;
    });
    var queues = this.queues();

    return locations.map(function (l) {
      var locationQueues = queues
        .filter(function (q) {
          return q.locationId == l.id;
        })
        .map(
          function (q) {
            return {
              description: q.description,
              id: q.id,
              name: q.name,
              selected: selectedQueueIds.indexOf(q.id) !== -1,
            };
          }.bind(self)
        );

      return {
        id: l.id,
        description: l.description,
        queues: locationQueues,
      };
    });
  }, this);
}

Object.setPrototypeOf(
  NotificationSettingsViewModel.prototype,
  AbstractViewModel.prototype
);

NotificationSettingsViewModel.prototype.PREF_ENABLED_QUEUES =
  "notificationEnabledQueues";
NotificationSettingsViewModel.prototype.PREF_SHOW_DESKTOP_NOTIFICATIONS =
  "showDesktopNotifications";

NotificationSettingsViewModel.prototype.save = function () {
  this.userPreferences.set(this.PREF_ENABLED_QUEUES, this.enabledQueues());

  this.userPreferences.set(
    this.PREF_SHOW_DESKTOP_NOTIFICATIONS,
    this.showDesktopNotifications()
  );
};

NotificationSettingsViewModel.prototype.queueHasNotificationsEnabled = function (
  id
) {
  return this.enabledQueues.indexOf(id) !== -1;
};

NotificationSettingsViewModel.prototype.clear = function () {
  this.enabledQueues.removeAll();
};

/**
 * Loads the Queues with Notifications enabled from UserPreferences
 */
NotificationSettingsViewModel.prototype.load = function () {
  this.enabledQueues.removeAll();

  this.migrateShowDesktopNotifications();

  var enabledQueues = this.userPreferences.get(this.PREF_ENABLED_QUEUES);
  if (Array.isArray(enabledQueues)) {
    this.enabledQueues(enabledQueues);
  }
};

NotificationSettingsViewModel.prototype.requestPermissionOrDisable = function (
  enabledQueues
) {
  var required = enabledQueues.length > 0;

  if (required === true) {
    if (Notification.permission === "granted") {
      this.showDesktopNotifications(true);
    } else {
      Notification.requestPermission(
        function (permission) {
          if (permission === "granted") {
            this.showDesktopNotifications(true);
          } else {
            this.enabledQueues([]);
            this.showDesktopNotifications(false);

            if (permission === "denied") {
              alert(
                "Sorry, you must allow or reset your browser's Notification permissions."
              );
            }
          }
        }.bind(this)
      );
    }
  }
};

/**
 * Users won't have a `notificationsEnabledQueues` preference when this is
 * released.
 *
 * If a User has `Show Desktop Notifications` enabled, this is will
 * populate `notificationEnabledQueues` with all the currently selected Queue IDs
 */
NotificationSettingsViewModel.prototype.migrateShowDesktopNotifications = function () {
  var showDesktopNotifications = this.userPreferences.get(
    this.PREF_SHOW_DESKTOP_NOTIFICATIONS
  );

  var notificationEnabledQueues = this.userPreferences.get(
    this.PREF_ENABLED_QUEUES
  );

  var migrate =
    showDesktopNotifications && notificationEnabledQueues.length === 0;

  if (migrate) {
    console.log("migrated settings")
    var selectedQueueIds = this.selectedQueues().map(function (q) { return q.id })
    this.userPreferences.set(this.PREF_ENABLED_QUEUES, selectedQueueIds)
    this.userPreferences.store();
  }
};

module.exports = NotificationSettingsViewModel;
